/**
 * SILVERBACK MOTO CO. - SHOPIFY THEME JS
 * Premium Motorcycling Apparel
 */

(function() {
  'use strict';

  // ================================
  // UTILITY FUNCTIONS
  // ================================
  const $ = (selector, context = document) => context.querySelector(selector);
  const $$ = (selector, context = document) => [...context.querySelectorAll(selector)];
  
  const debounce = (fn, delay) => {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => fn(...args), delay);
    };
  };

  const prefersReducedMotion = () => 
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // // ================================
  // // ANNOUNCEMENT BAR - Continuous Scrolling Ticker
  // // ================================
  // class AnnouncementBar {
  //   constructor(element) {
  //     this.element = element;
  //     this.track = element.querySelector('[data-announcement-track]');
  //     this.messageEl = element.querySelector('[data-announcement-message]');
      
  //     if (!this.track || !this.messageEl) return;
      
  //     try {
  //       this.messages = JSON.parse(this.track.dataset.messages || '[]');
  //     } catch(e) {
  //       this.messages = [];
  //     }
      
  //     this.currentIndex = 0;
      
  //     if (this.messages.length > 0) {
  //       this.init();
  //     }
  //   }

  //   init() {
  //     // Set initial message
  //     const firstMessage = this.messages[0] ? this.messages[0].trim() : '';
  //     this.messageEl.textContent = firstMessage;
      
  //     // Calculate animation duration based on text length
  //     this.setAnimationDuration();
      
  //     // If multiple messages, rotate on each animation cycle
  //     if (this.messages.length > 1) {
  //       this.track.addEventListener('animationiteration', () => {
  //         this.nextMessage();
  //       });
  //     }
      
  //     // Recalculate on resize
  //     window.addEventListener('resize', this.debounce(() => {
  //       this.setAnimationDuration();
  //     }, 250));
  //   }

  //   setAnimationDuration() {
  //     const messageWidth = this.messageEl.offsetWidth;
  //     const viewportWidth = window.innerWidth;
  //     const totalDistance = messageWidth + viewportWidth;
      
  //     // ADJUST THIS VALUE TO CONTROL SPEED
  //     // Lower = slower, Higher = faster
  //     const pixelsPerSecond = 50;
      
  //     const duration = totalDistance / pixelsPerSecond;
  //     this.track.style.setProperty('--ticker-duration', `${Math.max(duration, 8)}s`);
  //   }

  //   nextMessage() {
  //     this.currentIndex = (this.currentIndex + 1) % this.messages.length;
  //     const nextMsg = this.messages[this.currentIndex].trim();
  //     this.messageEl.textContent = nextMsg;
      
  //     // Recalculate duration for new message length
  //     requestAnimationFrame(() => {
  //       this.setAnimationDuration();
  //     });
  //   }

  //   debounce(fn, delay) {
  //     let timeout;
  //     return (...args) => {
  //       clearTimeout(timeout);
  //       timeout = setTimeout(() => fn(...args), delay);
  //     };
  //   }
  // }

  // ================================
  // ANNOUNCEMENT BAR - Flicker Effect
  // ================================
  class AnnouncementBar {
    constructor(element) {
      this.element = element;
      this.messageEl = element.querySelector('[data-announcement-message]');
      this.closeBtn = element.querySelector('[data-announcement-close]');
      
      if (!this.messageEl) return;
      
      // Check if user closed the bar this session
      if (sessionStorage.getItem('announcementBarClosed') === 'true') {
        this.element.classList.add('announcement-bar--hidden');
        return;
      }
      
      try {
        this.messages = JSON.parse(this.element.dataset.messages || '[]');
      } catch(e) {
        this.messages = [];
      }
      
      // Display duration in seconds (time message stays visible)
      this.displayDuration = parseInt(this.element.dataset.duration, 10) || 6;
      this.currentIndex = 0;
      this.isAnimating = false;
      
      if (this.messages.length > 0) {
        this.init();
      }
    }

    init() {
      // Set initial message
      this.messageEl.textContent = this.messages[0].trim();
      
      // Start flicker in animation
      this.flickerIn();
      
      // Bind close button
      if (this.closeBtn) {
        this.closeBtn.addEventListener('click', () => this.close());
      }
    }

    flickerIn() {
      if (this.isAnimating) return;
      this.isAnimating = true;
      
      // Remove any existing classes
      this.messageEl.classList.remove('announcement-bar__message--visible', 'announcement-bar__message--flicker-out');
      
      // Add flicker-in animation
      this.messageEl.classList.add('announcement-bar__message--flicker-in');
      
      // After flicker-in completes (0.6s), set to visible and start display timer
      setTimeout(() => {
        this.messageEl.classList.remove('announcement-bar__message--flicker-in');
        this.messageEl.classList.add('announcement-bar__message--visible');
        this.isAnimating = false;
        
        // Start timer for display duration
        this.startDisplayTimer();
      }, 600);
    }

    startDisplayTimer() {
      // Only cycle if there are multiple messages
      if (this.messages.length <= 1) return;
      
      setTimeout(() => {
        this.flickerOut();
      }, this.displayDuration * 1000);
    }

    flickerOut() {
      if (this.isAnimating) return;
      this.isAnimating = true;
      
      // Remove visible class and add flicker-out
      this.messageEl.classList.remove('announcement-bar__message--visible');
      this.messageEl.classList.add('announcement-bar__message--flicker-out');
      
      // After flicker-out completes (0.3s), load next message
      setTimeout(() => {
        this.messageEl.classList.remove('announcement-bar__message--flicker-out');
        this.isAnimating = false;
        
        // Move to next message
        this.currentIndex = (this.currentIndex + 1) % this.messages.length;
        this.messageEl.textContent = this.messages[this.currentIndex].trim();
        
        // Flicker in the new message
        this.flickerIn();
      }, 300);
    }

    close() {
      // Store in sessionStorage (persists across navigation, clears on tab close/refresh)
      sessionStorage.setItem('announcementBarClosed', 'true');
      
      // Hide the bar
      this.element.classList.add('announcement-bar--hidden');
    }
  }

  // ================================
  // HEADER
  // ================================
  class Header {
    constructor(element) {
      this.element = element;
      this.lastScrollY = 0;
      this.isHidden = false;
      this.threshold = 100;
      
      this.init();
    }

    init() {
      this.bindEvents();
    }

    bindEvents() {
      window.addEventListener('scroll', debounce(() => this.onScroll(), 10));
    }

    onScroll() {
      const currentScrollY = window.scrollY;
      
      // Add scrolled state
      if (currentScrollY > 50) {
        this.element.classList.add('header--scrolled');
      } else {
        this.element.classList.remove('header--scrolled');
      }

      // Hide/show on scroll direction (mobile only)
      if (window.innerWidth < 1024) {
        if (currentScrollY > this.lastScrollY && currentScrollY > this.threshold) {
          if (!this.isHidden) {
            this.element.classList.add('header--hidden');
            this.isHidden = true;
          }
        } else {
          if (this.isHidden) {
            this.element.classList.remove('header--hidden');
            this.isHidden = false;
          }
        }
      }
      
      this.lastScrollY = currentScrollY;
    }
  }

  // ================================
  // MEGA MENU
  // ================================
  class MegaMenu {
    constructor() {
      this.triggers = $$('[data-mega-menu-trigger]');
      this.menus = $$('[data-mega-menu]');
      this.closeButtons = $$('[data-mega-menu-close]');
      this.activeMenu = null;
      
      this.init();
    }

    init() {
      this.bindEvents();
    }

    bindEvents() {
      this.triggers.forEach(trigger => {
        trigger.addEventListener('mouseenter', () => this.open(trigger.dataset.megaMenuTrigger));
        trigger.addEventListener('click', (e) => {
          e.preventDefault();
          this.toggle(trigger.dataset.megaMenuTrigger);
        });
      });

      this.menus.forEach(menu => {
        menu.addEventListener('mouseleave', () => this.close());
      });

      this.closeButtons.forEach(btn => {
        btn.addEventListener('click', () => this.close());
      });

      // Close on escape
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') this.close();
      });

      // Close when clicking outside
      document.addEventListener('click', (e) => {
        if (!e.target.closest('[data-mega-menu]') && !e.target.closest('[data-mega-menu-trigger]')) {
          this.close();
        }
      });
    }

    open(menuId) {
      // Close any open menu first
      this.close();
      
      const menu = $(`[data-mega-menu="${menuId}"]`);
      const trigger = $(`[data-mega-menu-trigger="${menuId}"]`);
      
      if (menu) {
        menu.classList.add('mega-menu--open');
        trigger?.parentElement.classList.add('nav__item--open');
        this.activeMenu = menu;
      }
    }

    close() {
      this.menus.forEach(menu => menu.classList.remove('mega-menu--open'));
      $$('.nav__item--open').forEach(item => item.classList.remove('nav__item--open'));
      this.activeMenu = null;
    }

    toggle(menuId) {
      if (this.activeMenu?.dataset.megaMenu === menuId) {
        this.close();
      } else {
        this.open(menuId);
      }
    }
  }

  // ================================
  // MOBILE MENU
  // ================================
  class MobileMenu {
    constructor() {
      this.menu = $('#mobile-menu');
      this.openBtn = $('[data-mobile-menu-open]');
      this.closeBtn = $('[data-mobile-menu-close]');
      this.tabs = $$('[data-mobile-menu-tab]');
      this.tabContents = $$('[data-mobile-menu-content]');
      this.categories = $$('.mobile-menu__category');
      
      if (this.menu) {
        this.init();
      }
    }

    init() {
      this.bindEvents();
    }

    bindEvents() {
      this.openBtn?.addEventListener('click', () => this.open());
      this.closeBtn?.addEventListener('click', () => this.close());

      // Tab switching
      this.tabs.forEach(tab => {
        tab.addEventListener('click', () => this.switchTab(tab.dataset.mobileMenuTab));
      });

      // Category accordion
      this.categories.forEach(category => {
        const btn = $('.mobile-menu__category-btn', category);
        btn?.addEventListener('click', () => this.toggleCategory(category));
      });

      // Close on escape
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') this.close();
      });
    }

    open() {
      this.menu.classList.add('mobile-menu--open');
      document.body.style.overflow = 'hidden';
    }

    close() {
      this.menu.classList.remove('mobile-menu--open');
      document.body.style.overflow = '';
    }

    switchTab(tabId) {
      this.tabs.forEach(tab => {
        tab.classList.toggle('mobile-menu__tab--active', tab.dataset.mobileMenuTab === tabId);
      });

      this.tabContents.forEach(content => {
        content.style.display = content.dataset.mobileMenuContent === tabId ? 'block' : 'none';
      });
    }

    toggleCategory(category) {
      category.classList.toggle('mobile-menu__category--open');
    }
  }

  // ================================
  // PRODUCT GALLERY
  // ================================
  class ProductGallery {
    constructor(element) {
      this.element = element;
      this.mainImage = $('.product__main-image img', element);
      this.thumbnails = $$('.product__thumbnail', element);
      
      if (this.mainImage && this.thumbnails.length) {
        this.init();
      }
    }

    init() {
      this.bindEvents();
    }

    bindEvents() {
      this.thumbnails.forEach(thumb => {
        thumb.addEventListener('click', () => this.selectImage(thumb));
      });
    }

    selectImage(thumbnail) {
      const newSrc = thumbnail.dataset.src;
      const newAlt = thumbnail.dataset.alt || '';
      
      // Update main image
      this.mainImage.src = newSrc;
      this.mainImage.alt = newAlt;
      
      // Update active state
      this.thumbnails.forEach(t => t.classList.remove('product__thumbnail--active'));
      thumbnail.classList.add('product__thumbnail--active');
    }
  }

  // ================================
  // PRODUCT VARIANTS
  // ================================
  class ProductVariants {
    constructor(element) {
      this.element = element;
      this.colorSwatches = $$('.product__color-swatch', element);
      this.sizeButtons = $$('.product__size', element);
      this.priceEl = $('.product__price', element);
      this.addToCartBtn = $('.product__atc-btn', element);
      
      this.selectedColor = null;
      this.selectedSize = null;
      
      this.init();
    }

    init() {
      this.bindEvents();
      this.setInitialSelections();
    }

    bindEvents() {
      this.colorSwatches.forEach(swatch => {
        swatch.addEventListener('click', () => this.selectColor(swatch));
      });

      this.sizeButtons.forEach(btn => {
        if (!btn.classList.contains('product__size--disabled')) {
          btn.addEventListener('click', () => this.selectSize(btn));
        }
      });
    }

    setInitialSelections() {
      const activeColor = $('.product__color-swatch--active', this.element);
      const activeSize = $('.product__size--active', this.element);
      
      if (activeColor) this.selectedColor = activeColor.dataset.color;
      if (activeSize) this.selectedSize = activeSize.dataset.size;
    }

    selectColor(swatch) {
      this.colorSwatches.forEach(s => s.classList.remove('product__color-swatch--active'));
      swatch.classList.add('product__color-swatch--active');
      this.selectedColor = swatch.dataset.color;
      
      // Update variant if needed
      this.updateVariant();
    }

    selectSize(btn) {
      this.sizeButtons.forEach(b => b.classList.remove('product__size--active'));
      btn.classList.add('product__size--active');
      this.selectedSize = btn.dataset.size;
      
      // Update variant
      this.updateVariant();
    }

    updateVariant() {
      // This would typically update the selected variant based on color + size
      // and update the price/availability accordingly
      console.log('Selected:', this.selectedColor, this.selectedSize);
    }
  }

  // ================================
  // PRODUCT ACCORDIONS
  // ================================
  class ProductAccordions {
    constructor(element) {
      this.element = element;
      this.accordions = $$('.product__accordion', element);
      
      if (this.accordions.length) {
        this.init();
      }
    }

    init() {
      this.bindEvents();
    }

    bindEvents() {
      this.accordions.forEach(accordion => {
        const btn = $('.product__accordion-btn', accordion);
        btn?.addEventListener('click', () => this.toggle(accordion));
      });
    }

    toggle(accordion) {
      accordion.classList.toggle('product__accordion--open');
    }
  }

  // ================================
  // TESTIMONIALS CAROUSEL
  // ================================

  class TestimonialsCarousel {
    constructor(element) {
      this.element = element;
      this.track = element.querySelector('[data-testimonials-track]');
      this.slides = element.querySelectorAll('[data-testimonial-slide]');
      
      if (!this.track || this.slides.length === 0) return;
      
      this.currentIndex = 0;
      this.totalSlides = this.slides.length;
      
      this.init();
    }

    init() {
      this.showSlide(0);
      
      // Bind all prev/next buttons (one set per slide)
      this.element.querySelectorAll('[data-testimonial-prev]').forEach(btn => {
        btn.addEventListener('click', () => this.prev());
      });
      
      this.element.querySelectorAll('[data-testimonial-next]').forEach(btn => {
        btn.addEventListener('click', () => this.next());
      });
    }

    showSlide(index) {
      this.slides.forEach(slide => {
        slide.classList.remove('testimonial--active');
      });
      
      if (this.slides[index]) {
        this.slides[index].classList.add('testimonial--active');
      }
      
      this.currentIndex = index;
    }

    prev() {
      if (this.currentIndex > 0) {
        this.showSlide(this.currentIndex - 1);
      } else {
        this.showSlide(this.totalSlides - 1);
      }
    }

    next() {
      if (this.currentIndex < this.totalSlides - 1) {
        this.showSlide(this.currentIndex + 1);
      } else {
        this.showSlide(0);
      }
    }
  }

  // Initialize Testimonials
  const testimonialsCarousel = document.querySelector('[data-testimonials-carousel]');
  if (testimonialsCarousel) {
    new TestimonialsCarousel(testimonialsCarousel);
  }

  // ================================
  // COPY PROMO CODE
  // ================================
  class PromoCopy {
    constructor() {
      this.buttons = $$('[data-copy-code]');
      this.init();
    }

    init() {
      this.buttons.forEach(btn => {
        btn.addEventListener('click', () => this.copy(btn));
      });
    }

    async copy(btn) {
      const code = btn.dataset.copyCode;
      const originalText = btn.textContent;
      
      try {
        await navigator.clipboard.writeText(code);
        btn.textContent = 'Copied!';
      } catch (err) {
        // Fallback
        const textarea = document.createElement('textarea');
        textarea.value = code;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        document.body.removeChild(textarea);
        btn.textContent = 'Copied!';
      }
      
      setTimeout(() => {
        btn.textContent = originalText;
      }, 2000);
    }
  }

  // ================================
  // SPLASH SCREEN
  // ================================
  class SplashScreen {
    constructor() {
      this.element = $('#splash-screen');
      this.duration = parseInt(this.element?.dataset.duration, 10) || 800;
      
      if (this.element && !sessionStorage.getItem('splashShown')) {
        this.init();
      } else if (this.element) {
        this.element.remove();
      }
    }

    init() {
      setTimeout(() => {
        this.element.classList.add('splash-screen--hidden');
        sessionStorage.setItem('splashShown', 'true');
        
        setTimeout(() => {
          this.element.remove();
        }, 300);
      }, this.duration);
    }
  }

  // ================================
  // PRODUCT CARD HOVER
  // ================================
  class ProductCardHover {
    constructor() {
      this.cards = $$('.product-card');
      this.init();
    }

    init() {
      this.cards.forEach(card => {
        const primaryImg = $('.product-card__image--primary', card);
        const hoverImg = $('.product-card__image--hover', card);
        
        if (primaryImg && hoverImg) {
          // Preload hover image
          const img = new Image();
          img.src = hoverImg.src;
        }
      });
    }
  }

  // ================================
  // LAZY LOADING
  // ================================
  class LazyLoad {
    constructor() {
      this.images = $$('img[data-src]');
      
      if ('IntersectionObserver' in window) {
        this.init();
      } else {
        this.loadAll();
      }
    }

    init() {
      const options = {
        rootMargin: '50px 0px',
        threshold: 0.01
      };

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.loadImage(entry.target);
            this.observer.unobserve(entry.target);
          }
        });
      }, options);

      this.images.forEach(img => this.observer.observe(img));
    }

    loadImage(img) {
      img.src = img.dataset.src;
      if (img.dataset.srcset) {
        img.srcset = img.dataset.srcset;
      }
      img.removeAttribute('data-src');
      img.removeAttribute('data-srcset');
    }

    loadAll() {
      this.images.forEach(img => this.loadImage(img));
    }
  }

  // ================================
  // INITIALIZATION
  // ================================
  document.addEventListener('DOMContentLoaded', () => {
    // Initialize components
    const announcementBar = $('.announcement-bar');
    if (announcementBar) new AnnouncementBar(announcementBar);

    const header = $('.header');
    if (header) new Header(header);

    new MegaMenu();
    new MobileMenu();

    // Support both class naming conventions for product page
    const productGallery = $('.product__gallery') || $('.product-main__gallery');
    if (productGallery) new ProductGallery(productGallery);

    const productInfo = $('.product__info') || $('.product-main__info');
    if (productInfo) {
      new ProductVariants(productInfo);
      new ProductAccordions(productInfo);
    }
    
    // Product Main Section (new naming convention)
    const productMain = $('[data-product-section]');
    if (productMain) {
      new ProductMainSection(productMain);
    }

    const testimonials = $('.testimonials');
    if (testimonials) new TestimonialsCarousel(testimonials);

    new PromoCopy();
    new SplashScreen();
    new ProductCardHover();
    new LazyLoad();
    new StickyAddToCart();
  });

  // ================================
  // PRODUCT MAIN SECTION
  // ================================
  class ProductMainSection {
    constructor(element) {
      this.element = element;
      this.productData = JSON.parse($('[data-product-json]', element)?.textContent || '{}');
      this.mainImage = $('[data-main-image]', element);
      this.thumbnails = $$('[data-thumbnail]', element);
      this.colorSwatches = $$('[data-color-value]', element);
      this.sizePills = $$('[data-size-value]', element);
      this.variantIdInput = $('[data-variant-id]', element);
      this.addToCartBtn = $('[data-add-to-cart]', element);
      this.priceEl = $('[data-product-price]', element);
      this.accordions = $$('[data-accordion-trigger]', element);
      
      this.selectedOptions = {};
      
      this.init();
    }

    init() {
      this.bindThumbnails();
      this.bindColorSwatches();
      this.bindSizePills();
      this.bindAccordions();
      this.setInitialOptions();
    }

    bindThumbnails() {
      this.thumbnails.forEach(thumb => {
        thumb.addEventListener('click', () => {
          const imageUrl = thumb.dataset.imageUrl;
          if (this.mainImage && imageUrl) {
            this.mainImage.src = imageUrl;
            this.thumbnails.forEach(t => t.classList.remove('product-main__thumbnail--active'));
            thumb.classList.add('product-main__thumbnail--active');
          }
        });
      });
    }

    bindColorSwatches() {
      this.colorSwatches.forEach(swatch => {
        swatch.addEventListener('click', () => {
          const color = swatch.dataset.colorValue;
          const variantId = swatch.dataset.variantId;
          
          this.colorSwatches.forEach(s => s.classList.remove('product-main__color-swatch--active'));
          swatch.classList.add('product-main__color-swatch--active');
          this.selectedOptions.color = color;
          
          if (variantId) {
            this.updateVariant(variantId);
          }
        });
      });
    }

    bindSizePills() {
      this.sizePills.forEach(pill => {
        if (!pill.disabled) {
          pill.addEventListener('click', () => {
            const size = pill.dataset.sizeValue;
            this.sizePills.forEach(p => p.classList.remove('product-main__size-pill--active'));
            pill.classList.add('product-main__size-pill--active');
            this.selectedOptions.size = size;
            this.findAndUpdateVariant();
          });
        }
      });
    }

    bindAccordions() {
      this.accordions.forEach(trigger => {
        trigger.addEventListener('click', () => {
          const accordion = trigger.closest('.product-main__accordion');
          const isOpen = accordion.classList.contains('product-main__accordion--open');
          
          // Optional: Close other accordions
          // $$('.product-main__accordion--open', this.element).forEach(a => a.classList.remove('product-main__accordion--open'));
          
          accordion.classList.toggle('product-main__accordion--open', !isOpen);
          trigger.setAttribute('aria-expanded', !isOpen);
        });
      });
    }

    setInitialOptions() {
      const activeColor = $('.product-main__color-swatch--active', this.element);
      const activeSize = $('.product-main__size-pill--active', this.element);
      
      if (activeColor) this.selectedOptions.color = activeColor.dataset.colorValue;
      if (activeSize) this.selectedOptions.size = activeSize.dataset.sizeValue;
    }

    findAndUpdateVariant() {
      if (!this.productData.variants) return;
      
      const variant = this.productData.variants.find(v => {
        return (this.selectedOptions.color ? v.option1 === this.selectedOptions.color || v.option2 === this.selectedOptions.color : true) &&
               (this.selectedOptions.size ? v.option1 === this.selectedOptions.size || v.option2 === this.selectedOptions.size : true);
      });
      
      if (variant) {
        this.updateVariant(variant.id);
      }
    }

    updateVariant(variantId) {
      const variant = this.productData.variants.find(v => v.id === parseInt(variantId));
      if (!variant) return;
      
      // Update hidden input
      if (this.variantIdInput) {
        this.variantIdInput.value = variantId;
      }
      
      // Update price
      if (this.priceEl) {
        const price = this.formatMoney(variant.price);
        const priceCurrentEl = $('.product-main__price-current', this.priceEl);
        if (priceCurrentEl) priceCurrentEl.textContent = price;
        
        const priceCompareEl = $('.product-main__price-compare', this.priceEl);
        if (priceCompareEl) {
          if (variant.compare_at_price > variant.price) {
            priceCompareEl.textContent = this.formatMoney(variant.compare_at_price);
            priceCompareEl.style.display = '';
          } else {
            priceCompareEl.style.display = 'none';
          }
        }
      }
      
      // Update Add to Cart button
      if (this.addToCartBtn) {
        if (variant.available) {
          this.addToCartBtn.disabled = false;
          this.addToCartBtn.textContent = 'Add to Cart';
        } else {
          this.addToCartBtn.disabled = true;
          this.addToCartBtn.textContent = 'Sold Out';
        }
      }
      
      // Update main image if variant has featured image
      if (variant.featured_image && this.mainImage) {
        this.mainImage.src = variant.featured_image.src.replace(/\.(jpg|png|gif)/, '_1200x.$1');
      }
      
      // Update sticky ATC
      const stickyPrice = $('[data-sticky-price]');
      const stickyBtn = $('[data-sticky-add-to-cart]');
      if (stickyPrice) stickyPrice.textContent = this.formatMoney(variant.price);
      if (stickyBtn) {
        stickyBtn.disabled = !variant.available;
        stickyBtn.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
      }
      
      // Update URL
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variantId);
      window.history.replaceState({}, '', url.toString());
    }

    formatMoney(cents) {
      // Simple INR formatting - adjust based on shop currency
      return '₹' + (cents / 100).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace('.00', '');
    }
  }

  // ================================
  // STICKY ADD TO CART
  // ================================
  class StickyAddToCart {
    constructor() {
      this.stickyBar = $('[data-sticky-atc]');
      this.addToCartSection = $('[data-add-to-cart]')?.closest('.product-main__form');
      
      if (this.stickyBar && this.addToCartSection) {
        this.init();
      }
    }

    init() {
      this.bindScroll();
      this.bindClick();
    }

    bindScroll() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.stickyBar.classList.remove('product-sticky-atc--visible');
          } else {
            this.stickyBar.classList.add('product-sticky-atc--visible');
          }
        });
      }, { threshold: 0 });
      
      observer.observe(this.addToCartSection);
    }

    bindClick() {
      const stickyBtn = $('[data-sticky-add-to-cart]', this.stickyBar);
      stickyBtn?.addEventListener('click', () => {
        const mainAddToCart = $('[data-add-to-cart]');
        mainAddToCart?.click();
      });
    }
  }

  // ================================
  // SHOPIFY SECTION RENDERING
  // ================================
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target;
    
    // Re-initialize components in the loaded section
    const announcementBar = $('.announcement-bar', section);
    if (announcementBar) new AnnouncementBar(announcementBar);

    const productGallery = $('.product__gallery', section);
    if (productGallery) new ProductGallery(productGallery);

    const testimonials = $('.testimonials', section);
    if (testimonials) new TestimonialsCarousel(testimonials);
  });
})();
